import { SVGProps } from 'react';

const SvgDna = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M416 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 2.7-.1 5.4-.2 8H80.2c-.2-2.6-.2-5.3-.2-8C80 10.7 69.3 0 56 0S32 10.7 32 24c0 55.6 24.5 101.9 58.1 141.9 27.2 32.4 61.5 62 95.8 90.1-34.3 28.1-68.6 57.7-95.8 90.1C56.5 386.1 32 432.4 32 488c0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.7.1-5.4.2-8h287.6c.2 2.6.2 5.3.2 8 0 13.3 10.7 24 24 24s24-10.7 24-24c0-55.6-24.5-101.9-58.1-141.9-20.6-24.5-45.2-47.3-70.8-69.2-8.7 7.1-17.3 14.1-25.7 20.9l-2.2 1.8c-3.4 2.7-6.7 5.5-10.1 8.1 11.2 9.4 22.1 18.8 32.3 28.3h-115c22-20.4 46.7-40.4 72.2-61 .3-.2.5-.4.8-.6l.7-.6c41.3-33.4 84.7-68.6 117.7-107.9C391.5 125.9 416 79.6 416 24zM121.1 384h205.8c12.4 15.7 22.4 31.6 29.4 48H91.7c7-16.4 17-32.3 29.4-48zM91.7 80h264.6c-7 16.4-17 32.3-29.4 48H121.1c-12.4-15.7-22.4-31.6-29.4-48zm189.8 96c-17.8 16.4-37.2 32.6-57.5 49.1-20.3-16.5-39.7-32.7-57.5-49.1h115z" />
  </svg>
);
export default SvgDna;
